import { Button } from "./ui/Button";
import { ReimbursementTermsModal } from "@/shared/components/ReimbursementTermsModal";
import { CoverageModalTerms } from "@/shared/components/CoverageEditor";
import { useModal } from "../contexts/ModalProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons/faCircleQuestion";

// media
import InfoIcon from "@/shared/media/icons/CircleInfoProRegular.svg";
import { cn } from "../utils";
import Strings from "../utils/Strings.constants";

interface ReimbursementTermsButtonProps {
    termsInModal: CoverageModalTerms[];
    wrapperClass?: string;
    isTermsDefinitionsEnabled?: boolean;
}

export default function ReimbursementTerms(props: ReimbursementTermsButtonProps) {
    const { termsInModal, wrapperClass, isTermsDefinitionsEnabled = false } = props;
    const { showModal } = useModal();

    // Gated on the per-form-variant config flag (US-only); same pattern as isAiInsightsEnabled && showAiInsights.
    const isRestyled = isTermsDefinitionsEnabled;

    return (
        <div className={cn("flex w-full flex-row text-xs", isRestyled ? "text-content-brand-b" : "text-content-secondary", wrapperClass)}>
            <Button
                onClick={() => showModal("reimbursement-terms-modal", <ReimbursementTermsModal termsInModal={termsInModal} />)}
                className={cn("text-xs", isRestyled && "text-sm text-content-brand-b underline")}
                startDecorator={isRestyled ? <FontAwesomeIcon icon={faCircleQuestion} className="size-4 text-content-brand-b" /> : <InfoIcon className="h-4" />}
                variant="ghost"
                size="sm"
            >
                {Strings.TERMS_MEANING}
            </Button>
        </div>
    );
}
